export enum PosteActionsTypes {
  "LIST_POSTE" = "LIST_POSTE",
  "LIST_POSTE_BY_MATERIAL" = "LIST_POSTE_BY_MATERIAL",
  "LIST_POSTE_BY_SURVEY" = "LIST_POSTE_BY_SURVEY",
  "CREATE_POSTES" = "CREATE_POSTES",
  "DELETE_POSTE" = "DELETE_POSTE",
  "CREATE_POSTE" = "CREATE_POSTE",
  "UPDATE_POSTE" = "UPDATE_POSTE"
}

export enum PosteMutationsTypes {
  "SET_POSTE" = "SET_POSTE",
  "CREATE_POSTES" = "CREATE_POSTES",
  "CREATE_POSTE" = "CREATE_POSTE",
  "UPDATE_POSTE" = "UPDATE_POSTE",
  "DELETE_POSTE" = "DELETE_POSTE"
}

export enum PosteGettersTypes {
  "POSTE_BY_ID" = "POSTE_BY_ID",
  "POSTE_ALL_ID" = "POSTE_ALL_ID"
}
